import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";

function SharedCoupon() {
  const { couponId } = useParams();
  const [coupon, setCoupon] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCoupon = async () => {
      try {
        const res = await fetch(`https://zola.technology/api/company/coupons/id/${couponId}/`);
        if (!res.ok) throw new Error("Coupon not found");
        const data = await res.json();
        setCoupon(data);
      } catch (err) {
        setError("Coupon could not be loaded.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchCoupon();
  }, [couponId]);

  if (loading) return <div className="p-4 text-center">Loading coupon...</div>;
  if (error) return <div className="p-4 text-center text-red-500">{error}</div>;

  return (
    <div className="p-6 max-w-lg mx-auto bg-white rounded-xl shadow-md text-center">
      <h2 className="text-2xl font-bold mb-2">{coupon.name}</h2>
      <p className="text-xl text-purple-600 font-bold">
        {coupon.discount_type === "percentage"
          ? `${coupon.discount_value}% OFF`
          : `$${coupon.discount_value} OFF`}
      </p>
      <p className="text-sm text-gray-500 mt-2">
        Valid until: {coupon.valid_until ? new Date(coupon.valid_until).toLocaleDateString() : "No expiry"}
      </p>
      <p className="mt-4 text-sm text-gray-700">Coupon Code: {coupon.code || "Check your email"}</p>
    </div>
  );
}

export default SharedCoupon;
